import React from 'react';
import PlaqueImg from './assets/home-revamp/plaque.png'

const stats = [
  { value: '18M+', label: 'Chats' },
  { value: '10B+', label: 'Tokens' },
  { value: '50K+', label: 'Users' },
  { value: '10+', label: 'AI Apps' },
]

const CommPlaque2 = () => {
  return (
    <div className="pt-0 px-4 sm:px-8 md:px-12 lg:px-20">
      <div className="max-w-[1170px] flex flex-col max-w-480:flex-col-reverse lg:flex-row mx-auto items-center lg:items-center gap-10 lg:gap-16 pb-10 lg:py-16">
        <div className="flex-1 flex flex-col justify-center items-start gap-8 w-full lg:text-left text-center">
          <div className="flex flex-col gap-5 w-full lg:items-start items-center">
            <h2 className="text-black text-[36px] font-semibold font-['Inter']">
              Honored by OpenAI
            </h2>
            <p className="text-gray-600 text-sm sm:text-base font-normal font-['Inter'] leading-6 max-w-xl lg:max-w-none">
              We’re honored to receive recognition from OpenAI for the 10 billion tokens our customers have used. This milestone is made possible by the trust and support of our customers, thank you for being an essential part of our journey. We remain committed to delivering reliable, high-quality AI solutions that continue to create value for you.{' '}
              <a
                href="https://ai-pro.org/learn-ai/articles/ai-pro-org-receives-a-token-of-appreciation-from-open-ai-for-surpassing-the-10-billion-token-milestone"
                target="_blank"
                rel="noreferrer"
                className="text-[#3073D5] underline"
              >
                Read more.
              </a>
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-8 sm:gap-y-4 w-full justify-items-center mx-auto max-w-[250px] lg:max-w-none lg:flex lg:flex-row lg:flex-nowrap lg:justify-between lg:gap-x-4">
            {stats.map(({ value, label }) => (
              <div
                key={label}
                className="flex flex-col items-center lg:items-start gap-1 min-w-[72px]"
              >
                <span className="text-[#3073D5] text-[28px] font-bold font-['Inter'] leading-none">{value}</span>
                <span className="text-black text-[28px] font-semibold font-['Inter'] leading-none">{label}</span>
              </div>
            ))}
          </div>
     
        </div>
        <img src={PlaqueImg} alt="OpenAI commemorative plaque" className="flex-1 max-w-[550px] w-full flex items-center justify-center relative z-10"/>
      </div>
    </div>
  )
}

export default CommPlaque2